export default __webpack_public_path__ + "static/media/subscribeArrow.84454efa.svg";